module.exports = __webpack_public_path__ + "img/tp.b2ca7400.png";